var productCardMarkup = `

 {{#products}}
	<div class="wishlist-item wishlist-item-js" wishlist-product-id="{{empi}}" wishlist-variant-id="{{epi}}" > 
    
        <div class="wishlist--item__image-wrapper product-wishcard__image-wrapper js">
             <img  class="wishlist_img" src="{{iu}}" />
        </div> 
        
        <div class="wishlist-view-item__wrap">
          <span class="product-type">{{ct}}</span>
          <a class="wishlist--item__link" href="{{du}}">
            <span class="wish-view-item__title" aria-hidden="true">{{dt}}</span>
            <span class="wish-view-item__variant">{{vi}}</span>     
          </a> 

          <p class="package-contents-js" data-product-id="{{empi}}"></p>

          <div class="wishlist-btn-wrap">
            <quantity-input class="quantity quantity--wishlist">
              <button class="quantity__button no-js-hidden" name="minus" type="button">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
                </svg>
              </button>
              <input class="quantity__input quantity__input-{{epi}}"
                  type="number"
                  name="quantity"
                  id="Quantity-1"
                  min="1"
                  value="1"
                  form="{{vi}}"
                >
              <button class="quantity__button no-js-hidden" name="plus" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
                </svg>
              </button>
            </quantity-input>

            <button data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" class="wishlist--item__button button button--primary  add-to-cart">
              {{#isInCart}}IN CART{{/isInCart}}
              {{^isInCart}}Add To Cart{{/isInCart}}
            </button> 
          </div> 
        </div>
      
      <div class="wishlist-price-wrap">
        <div class="okendo-wish" data-okendo-id="{{empi}}"></div>
        <div class="wishlist--item__remove wishlist__remove-js" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}">
          <span>Remove from wishlist</span>
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M3.39267 4L0.37413 0.908225C0.230935 0.761557 0.230826 0.523648 0.373886 0.376841C0.516947 0.230034 0.749002 0.229922 0.892197 0.376591L3.97502 3.5342C3.99165 3.53304 4.00834 3.53304 4.02498 3.5342L7.1078 0.376591C7.25099 0.229922 7.48305 0.230034 7.62611 0.376841C7.76917 0.523648 7.76906 0.761557 7.62586 0.908225L4.60732 4L7.62586 7.09177C7.76906 7.23844 7.76917 7.47634 7.62611 7.62315C7.48305 7.76996 7.25099 7.77007 7.1078 7.6234L4.02498 4.4658C4.00834 4.46695 3.99165 4.46695 3.97502 4.4658L0.892197 7.6234C0.749002 7.77007 0.516947 7.76996 0.373886 7.62315C0.230826 7.47634 0.230935 7.23844 0.37413 7.09177L3.39267 4Z" fill="#001722"/>
          </svg>
        </div>  
        <div class="wishlist--item__price wishlist-price-js" wishlist-data-price="{{epi}}">
         
        </div> 
      </div>

    </div>
  {{/products}}
`;

function getVariantInfo(variants){
    try {
        let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []) , variantinfo;
        if(variantKeys.length > 0){
            variantinfo = variantKeys[0];
            if(variantinfo == "Default Title"){
                variantinfo = "";
            }
        } else {
            variantinfo = "";
        }
        return variantinfo;
    } catch(err){
        return variants;
    }
  }

function swymCallbackFn(){
  // gets called once Swym is ready
  var wishlistContentsContainer = document.getElementById("wishlist-items-container");
  let subtotal = 0;
  let total = 0;
  _swat.fetchWrtEventTypeET(
      function(products) {
          // Get wishlist items
          var formattedWishlistedProducts = products.map(function(p){
            let handle = p.du.split('products/')
            handle = handle[1]
            const url = `/products/${handle}?view=object-json`;
            const variant_wishlist_id = p.epi;
            const product_id = p.empi
            const productData = $.ajax({
                url: url
              }).done(function (data) {
                const html = document.createElement("div");
                html.innerHTML = data;
                let dataget =  JSON.parse(html.querySelector("[data-json-response]").innerHTML);

                  let package = $(".package-contents-js");
                  $(package).each(function() {
                    let pacage_id = $(this).attr( "data-product-id" );
                    if(dataget.id == pacage_id){ 
                      let package_contents = dataget.package_contents;
                      $(this).text(package_contents);
                    } 
                  });
                

                  let okendowishlist = $('.okendo-wish');
                  $(okendowishlist).each(function() {
                    let okendo_id = $(this).attr( "data-okendo-id" );
                    if(dataget.id == okendo_id && dataget.okendowishlist != null){ 
                      let okendo = '<div data-oke-reviews-product-listing-rating>'+dataget.okendowishlist+'</div>';
                      $(this).html(okendo);
                    }  
                  });

                  $(dataget.variants).each(function() {
                  
                    let var_Prod_id = $( this )[0].id;
                    let price_w = $(".wishlist-price-js[wishlist-data-price='"+var_Prod_id+"']");

                    if(var_Prod_id == variant_wishlist_id){
                     
                     let varianPrice = $( this )[0].price;
                     total = total + Number(varianPrice);

                     let varPriseformated = varianPrice/100;
                     varPriseformated = varPriseformated.toFixed(2);
                     let varianrPricHtml = '<span class="price-last" data-last-price="">$'+varPriseformated+'</span>';
                      
                     let varianrPriceLast = $(this)[0].compare_at_price;
                     
                     console.log(varianrPriceLast)
                     if(varianrPriceLast != null){
                      subtotal = subtotal + Number(varianrPriceLast)  ;
                      price_w.addClass('wishlist-sale');
                      let varianrPriceLastFormated = varianrPriceLast/100
                      varianrPriceLastFormated = varianrPriceLastFormated.toFixed(2);
                      
                      varianrPricHtml = '<span class="badge badge--bottom-left color-accent-2 badge-sale">Sale</span><span class="price" data-sale-price="">$'+ varianrPriceLastFormated + '</span>'+varianrPricHtml;
                     }
                     else{
                      subtotal = subtotal + Number(varianPrice)  ;
                     }
                     price_w.html(varianrPricHtml);
                    }

                
                  }); 
                  const subtotalconst = subtotal/100; 
                  const totalconast = total/100;
                 // subtotal = subtotal/100;
                  $('.wishlist-subtotal-js').text('$'+subtotalconst.toFixed(2));
                  $('.wishlist-total-js').text('$'+totalconast.toFixed(2));

                return JSON.parse(html.querySelector("[data-json-response]").innerHTML);
            });
  
                
                p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
                  p.isInCart =
                    _swat.platform.isInDeviceCart(p.epi) ||
                    p.et == _swat.EventTypes.addToCart;
                  p.variantinfo = p.variants ? getVariantInfo(p.variants) : "";
                  return p;
              }); 
          
              var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
                products: formattedWishlistedProducts,
              });
              wishlistContentsContainer.innerHTML = productCardsMarkup;
          
              attachClickListeners();
          
    }, window._swat.EventTypes.addToWishList);
 }

if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);



function onAddToCartClick(e){
  e.preventDefault();
// var productId = e.target.getAttribute("data-product-id");
  var variantId = e.target.getAttribute("data-variant-id");
 // var du = e.target.getAttribute("data-url");

  let quant = $('.quantity__input-'+variantId).val();

    $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: quant,
      id: variantId
    },
      dataType: 'json', 
     success: function (data) { 
     location.reload();
     }  
     });
}


$(".add-all-to-cart").click(function() {
  var itemID = $(".wishlist-item-js");
  items = [];
  itemID.each(function() {
   
    var variantId = $(this).attr("wishlist-variant-id");
	  var quantity = $('.quantity__input-'+variantId).val();
    quantity = Number(quantity);
    variantId = Number(variantId);
    items.push({
      quantity: quantity,
      id: variantId
    });
  });

$.post('/cart/add.js', {
  items: items
})
.done(function() {
  location.reload();
})
.fail(function() {
  console.log( "error" );
})
 
});



function removeFromWishlist(e) {
  e.preventDefault();
  var epi = $(this).attr("data-variant-id"); // get the selected variant id
  var empi = $(this).attr("data-product-id"); // get the selected product id


  window._swat.fetch(function(products) {
  
      products.forEach(function(product) {
          if (epi && empi && product.epi == epi && product.empi == empi) {
              _swat.removeFromWishList(product, console.log('removed'));
              location.reload();
          }
      })
  });
}

function attachClickListeners(){
  var addToCartButtons = document.getElementsByClassName("add-to-cart");

  for (var i = 0; i < addToCartButtons.length; i++) {
      addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }

  var removeFromWishlistButtons = document.getElementsByClassName("wishlist__remove-js");

  for (var n = 0; n < removeFromWishlistButtons.length; n++) {
      removeFromWishlistButtons[n].addEventListener('click', removeFromWishlist);
  }
}

